import { render } from "./ResendEmailInvitationModal.molecules.vue?vue&type=template&id=c0aa15dc&ts=true"
import script from "./ResendEmailInvitationModal.molecules.vue?vue&type=script&lang=ts"
export * from "./ResendEmailInvitationModal.molecules.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__